export default __webpack_public_path__ + "static/media/sticker_contacts.e276043e.svg";